import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from "@angular/forms";

  // Método para verificar si el formulario tiene controles requeridos
export function isFormRequired(form: FormControl<any> | FormGroup<any> | AbstractControl<any, any>[] | FormArray<any> , controlName: string | number): boolean {
    if(form instanceof FormGroup) {
        return Object.keys(form?.controls).some((control) => {
            if (controlName === control) {
                return form.get(controlName)!.hasValidator(Validators.required);
            }
            return false;
        });
    } else if (form instanceof FormArray) {
        return Object.keys(form.controls).some((control) => {
            if (controlName.toString() === control) {
                return form.get(controlName.toString())!.hasValidator(Validators.required);
            }
            return false;
        });
    } else {
        return false
    }

}